import FileProviderItemViewState, {
    ImageLoadState,
} from '../store/schema/FileProviderItemViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setThumbnailLoadState')(function setThumbnailLoadState(
    viewState: FileProviderItemViewState,
    newLoadState: ImageLoadState
) {
    viewState.thumbnail.loadState = newLoadState;
});
